import { createSelector } from 'reselect';
import getCustomer from './getCustomer';

const getCustomerBankAccount = createSelector(
  getCustomer,
  customer =>
    customer?.bank_account ?? {
      id: 0,
    },
);

export default getCustomerBankAccount;
